import { Component, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService,DealerService,SpinnerService } from '../services';
import { NgxPermissionsService } from 'ngx-permissions';
import { HttpClient } from '@angular/common/http';
import { first, map } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { interval } from 'rxjs/observable/interval';
import { Inotification } from '../models/notification';
import * as moment from 'moment';
import { User } from '../models';
import { SlicePipe, JsonPipe } from '@angular/common';
import { error } from '@angular/compiler/src/util';
import { analyzeAndValidateNgModules } from '@angular/compiler';

@Component({
    selector: 'layout-leftmenu',
    templateUrl: './leftmenu-layout.component.html'
})
export class LeftmenuLayoutComponent  implements OnInit {
    
    currentUser: User;
    topMenuBar: boolean;
    public syncTopMenuClick: boolean = true;
    menuDetails: any[] = [];
    private subscription: Subscription = new Subscription();
    isDashboardSubMenu: boolean = true;
    showIcon: string = 'fa-plus';
    constructor(private router: Router,
        private authenticationService: AuthenticationService,
        private ngxPermissionsService: NgxPermissionsService,
        private dealerService: DealerService,private http: HttpClient,
        private spinnerService: SpinnerService
    ) {
        var user = this.authenticationService.getAuthorizationToken();
        authenticationService.topMenuBar.subscribe(value => {
            this.syncTopMenuClick = !value;
        });
        
    }
    ngOnInit(): void {
        this.currentUser;
        this.GetORPMenuJson();
    }
    dashboardSubMenu(){
        if(this.isDashboardSubMenu == false){
            this.showIcon = 'fa-plus';
        }else{
            this.showIcon = 'fa-minus';
        }
        this.isDashboardSubMenu = !this.isDashboardSubMenu;
    }
    Leftmenuclick() {
        this.topMenuBar = !this.topMenuBar;
        this.authenticationService.topMenuBar.next(this.topMenuBar);
    }
    SelectedMenuHighlight(path) {
        return window.location.href.indexOf(path) > -1;
    }

    GetORPMenuJson() {
        this.http.get('assets/data/menu.eng.json')
        let filename = ('menu.eng.json');
  
        var Currenturl = this.router.url;
        var ReAppName;

        this.http.get<any>('assets/data/menu.eng.json')
        .subscribe((data) => {          
            data.forEach(e => {
                var splitted = Currenturl.split("/")
                if(splitted.length == 4){
                    Currenturl = splitted[0]+'/'+splitted[1]+'/'+splitted[2]
                }
                if(Currenturl == e.path){
                    ReAppName = e.AppName
                   
                    data.forEach(k => {
                        
                        if (k.AppName.indexOf(ReAppName)> -1) {
                        this.menuDetails.push(k);
                        }
                    });
                }
        });
     //   console.log(this.menuDetails)

    });



}

   
   
}
